import React, {useEffect} from 'react';
import Card from '@mui/material/Card';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';

export default function EntryThreeConservation({code, conservation}) {
  const {values, setFieldValue} = useFormikContext();
  const rejected = conservation?.state === 'rejected';

  useEffect(() => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      let day = date.getDate();
      day = day < 10 ? `0${day}` : day;
      return `${year}-${month}-${day}`;
    };

    if (values?.completion_date || values?.incoming_date) {
      const formattedCompletionDate = formatDate(values.completion_date);
      const formattedIncomingDate = formatDate(values.incoming_date);
      setFieldValue('completion_date', formattedCompletionDate);
      setFieldValue('incoming_date', formattedIncomingDate);
    }
  }, [values.completion_date, values.incoming_date, setFieldValue]);

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Incoming Date'}
               name={`incoming_date`} type={'date'}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Condition Assessment'}
               name={`condition_assessment`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Treatment Plan'}
               name={`treatment_plan`} sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>

        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Completion date'}
               name={`completion_date`} sx={{mt: 1.5}} type={'date'} disabled={rejected}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Condition Assessment'}
               name={`condition_assessment_after`} sx={{mt: 1.5}} disabled={rejected}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
      </Card>
    </div>
  );
}